module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-5-edbc19fd60c79ac4c71f9f3c9559d154ac45cefd780d1d209f78e5ab8cc44f86.svg";